export const CHANGE_WHOLESALERS_VERSION = 'CHANGE_WHOLESALERS_VERSION';
